import { forwardRef } from 'react';
import DallasSvgIcon, { Props } from '~/app/_ui/Dallas/Icons/DallasSvgIcon';

const DallasSvgIconVerifiedOutlined = forwardRef<SVGSVGElement, Props>(
  function DallasSvgIconVerifiedOutlined(props: Props, ref) {
    return (
      <DallasSvgIcon {...props} ref={ref} viewBox="0 -960 960 960">
        <path
          d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z"
          fill="currentColor"
        />
      </DallasSvgIcon>
    );
  },
);

export default DallasSvgIconVerifiedOutlined;
